/** PDF code lists use whitespace; also tolerate comma/semicolon separated lists. */
export function parseAcsCodes(text: string): string[] {
  return Array.from(new Set((text || '').split(/[\s,;]+/)
    .map(value => value.trim().toUpperCase()).filter(value => !!value)));
}
